import React from "react";
import {
  PassportCategoryId,
  PassportDocumentCategory,
  PassportDocumentType,
} from "../../../../messages";
import { OrientationLanguages } from "../../../../messages/Video";
import { withDefault } from "../../../../utils/withDefault";
import {
  CategorizedList,
  CategorizedListContent,
  CategorizedListItem,
  CategorziedListHeader,
} from "../../../Generic/CategorizedList/CategorizedList";
import PassportCategoryStatus from "../PassportCategoryStatus/PassportCategoryStatus";

interface Props {
  category: PassportDocumentCategory;
  language: OrientationLanguages;
  isContentOpen: boolean;
  onClickPassportDocumentType: (documentType: PassportDocumentType) => void;
  onClickCatergoryHeader: (
    passportCategoryId: PassportCategoryId,
    contentRef: React.RefObject<HTMLDivElement>
  ) => void;
}

const PassportCategory = (props: Props) => {
  const contentRef = React.useRef<HTMLDivElement>(null);

  const { category, language, isContentOpen, onClickPassportDocumentType, onClickCatergoryHeader } =
    props;

  const handleClickCategoryHeader = React.useCallback(() => {
    onClickCatergoryHeader(category.id, contentRef);
  }, [category.id, onClickCatergoryHeader]);

  return (
    <CategorizedList>
      <CategorziedListHeader
        onClick={handleClickCategoryHeader}
        primaryText={category.name[language]}
      />
      <CategorizedListContent ref={contentRef} isOpen={isContentOpen}>
        {category.documents.map((document) => (
          <CategorizedListItem
            key={document.id.toString()}
            onClick={() => onClickPassportDocumentType(document)}
            primaryText={withDefault(
              document.documentName[language],
              document.documentName.English
            )}
          >
            <PassportCategoryStatus
              expiryDays={document.expiryDays}
              verificationStatus={document.verificationStatus}
              language={language}
            />
          </CategorizedListItem>
        ))}
      </CategorizedListContent>
    </CategorizedList>
  );
};

export default React.memo(PassportCategory);
